var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{'active': _vm.isActive},on:{"click":_vm.changeStatus}},[_c('span',[_c('i',{staticClass:"icon-plus"}),_vm._v(_vm._s(_vm.category.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }